// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 领取服务体验券 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /vip-coupon/apply */
export async function vipCouponApplyUsingPOST(
  body: API.VipCouponInfoReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVipCouponInfoResp>("/vip-coupon/apply", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取服务体验券模板详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /vip-coupon/template/info */
export async function vipCouponTemplateInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vipCouponTemplateInfoUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVipCouponTemplateInfoResp>(
    "/vip-coupon/template/info",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}
